import { createAsyncThunk } from '@reduxjs/toolkit'
import { evolveLandingManagementAPI } from 'src/api/evolve-landing-management'
import {
  IBannerBottom,
  IBannerTop,
} from 'src/components/evolve-landing-page-management/banner/bannerSchema'
import { IAddFeatureRequest } from 'src/components/evolve-landing-page-management/feature/FeatureDetailModal'
import { IDownload } from 'src/components/evolve-landing-page-management/download/downloadSchema'
import { IMemberUse } from 'src/components/evolve-landing-page-management/memberUse/memberUseSchema'
import {
  IAddPostRequest,
  IHeadingContent,
  IHeadingType,
} from 'src/interfaces/evolve-landing-management'
import { IEvolveSeoPageSchema } from 'src/components/evolve-landing-page-management/seoConfig/seoConfigSchema'
import { IJoinOurCommunitySchema } from 'src/components/evolve-landing-page-management/joinOurCommunity/JoinOurCommunitySchema'

// Banner Actions
export const createEvolveBannerTopAction = createAsyncThunk(
  'evolve-landing-management/banner-top/create',
  async (params: IBannerTop) => {
    try {
      const res = await evolveLandingManagementAPI.createBannerTop(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getEvolveBannerTopAction = createAsyncThunk(
  'evolve-landing-management/banner-top/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getBannerTop()
      return res
    } catch (error) {
      throw error
    }
  }
)
//banner bottom
export const createEvolveBannerBottomAction = createAsyncThunk(
  'evolve-landing-management/banner-bottom/create',
  async (params: IBannerBottom) => {
    try {
      const res = await evolveLandingManagementAPI.createBannerBottom(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getEvolveBannerBottomAction = createAsyncThunk(
  'evolve-landing-management/banner-bottom/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getBannerBottom()
      return res
    } catch (error) {
      throw error
    }
  }
)
// Feature Actions
export const getEvolveFeatureListAction = createAsyncThunk(
  'evolve-landing-management/feature/get-list',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getEvolveFeatureList()
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getEvolveFeatureByIdAction = createAsyncThunk(
  'evolve-landing-management/feature/get-by-id',
  async (id: number) => {
    try {
      const res = await evolveLandingManagementAPI.getEvolveFeatureById(id)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const createEvolveFeatureAction = createAsyncThunk(
  'evolve-landing-management/feature/create',
  async (params: IAddFeatureRequest) => {
    try {
      const res = await evolveLandingManagementAPI.createEvolveFeature(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateEvolveFeatureAction = createAsyncThunk(
  'evolve-landing-management/feature/update',
  async ({ id, params }: { id: number; params: IAddFeatureRequest }) => {
    try {
      const res = await evolveLandingManagementAPI.updateEvolveFeature(
        id,
        params
      )
      return res
    } catch (error) {
      throw error
    }
  }
)

export const deleteEvolveFeatureAction = createAsyncThunk(
  'evolve-landing-management/feature/delete',
  async (id: number) => {
    try {
      await evolveLandingManagementAPI.deleteEvolveFeature(id)
      return { success: true, id }
    } catch (error) {
      throw error
    }
  }
)

// Download Actions
export const getEvolveDownloadAction = createAsyncThunk(
  'evolve-landing-management/download/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getEvolveDownload()
      return res
    } catch (error) {
      throw error
    }
  }
)

export const createEvolveDownloadAction = createAsyncThunk(
  'evolve-landing-management/download/create',
  async (params: IDownload) => {
    try {
      const res = await evolveLandingManagementAPI.createEvolveDownload(params)
      return res
    } catch (error) {
      throw error
    }
  }
)
// member use
export const getEvolveMemberUseAction = createAsyncThunk(
  'evolve-landing-management/member-use/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getMemberUseList()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const createEvolveMemberUseAction = createAsyncThunk(
  'evolve-landing-management/member-use/post',
  async (body: IMemberUse) => {
    try {
      const res = await evolveLandingManagementAPI.createMemberUse(body)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateEvolveMemberUseAction = createAsyncThunk(
  'evolve-landing-management/member-use/put',
  async ({ body, id }: { body: Partial<IMemberUse>; id: string }) => {
    try {
      const res = await evolveLandingManagementAPI.updateMemberUseById(body, id)
      return res
    } catch (error) {
      throw error
    }
  }
)
export const deleteEvolveMemberUseAction = createAsyncThunk(
  'evolve-landing-management/member-use/delete',
  async (id: string) => {
    try {
      const res = await evolveLandingManagementAPI.deleteMemberUse(id)
      return res
    } catch (error) {
      throw error
    }
  }
)
export const getHeadingContentAction = createAsyncThunk(
  'heading-management/heading/get',
  async (type: IHeadingType) => {
    try {
      const res = await evolveLandingManagementAPI.getHeadingContent(type)
      return res
    } catch (error) {
      throw error
    }
  }
)
export const changeHeadingAction = createAsyncThunk(
  'heading-management/heading/post',
  async ({ body, type }: { body: IHeadingContent; type: IHeadingType }) => {
    try {
      const res = await evolveLandingManagementAPI.changeHeadingContent(
        body,
        type
      )
      return res
    } catch (error) {
      throw error
    }
  }
)

//library
export const getLibraryAction = createAsyncThunk(
  'heading-management/library/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getLibraryDetail()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const addPostToLibraryAction = createAsyncThunk(
  'evolve-landing-management/library/add-post',
  async (body: { posts: IAddPostRequest[] }) => {
    try {
      const res = await evolveLandingManagementAPI.addPostToLibrary(body)
      return res
    } catch (error) {
      throw error
    }
  }
)

//seo
export const getEvolvePageSeoAction = createAsyncThunk(
  'evolve-landing-management/seo/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getEvolvePageSeo()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const updateEvolvePageSeoAction = createAsyncThunk(
  'evolve-landing-management/seo/update',
  async (body: IEvolveSeoPageSchema) => {
    try {
      const res = await evolveLandingManagementAPI.updateEvolvePageSeo(body)
      return res
    } catch (error) {
      throw error
    }
  }
)

// join our community
export const getEvolveOurCommunityAction = createAsyncThunk(
  'evolve-landing-management/community/get',
  async () => {
    try {
      const res = await evolveLandingManagementAPI.getEvolveOurCommunity()
      return res
    } catch (error) {
      throw error
    }
  }
)
export const updateEvolveOurCommunityAction = createAsyncThunk(
  'evolve-landing-management/community/update',
  async (body: IJoinOurCommunitySchema) => {
    try {
      const res = await evolveLandingManagementAPI.createEvolveOurCommunity(
        body
      )
      return res
    } catch (error) {
      throw error
    }
  }
)
